import { put, takeEvery, takeLeading, select } from "redux-saga/effects";
import UsersAction from "./usersAction";
import SettingsAction from "../settings/settingsAction";
import {apiGroupsService, apiInvestigationService, apiPermissionsService, apiUsersService} from "../../config/api";
import {
  transformGroupCheckList,
  transformInvestigations,
  transformInvestToEdit, transformUserPermissions,
} from "./usersTransformer";
import {getUser} from "../auth/authSelector";
import {notification} from "antd";
import i18n from "../../i18n";
import AuthAction from "../auth/authAction";
import {selectActiveGroup} from "./usersSelector";

function* getInvestigationsListForUsersSaga(action) {
  const user = action.payload;
  try {
    const { data } = yield apiInvestigationService.getAllInvTree();
    const transformed = transformInvestigations(data, user);
    yield put(UsersAction.setInvestigationsList(transformed));
  } catch (e) {
    yield SettingsAction.handleAPIError(e);
  }
}

function* getUserListSaga(action) {
  const filter = action.payload;
  const currentGroup = yield select(selectActiveGroup);

  yield put(UsersAction.setUsersLoading(true));
  try {
    if (currentGroup) {
      filter.groupId = currentGroup?.id;
    }
    const data = yield apiUsersService.getUsers(filter);
    //const data = yield apiUsersService.getUsers({page: pageNumber, size: pageSize });
    //console.log('API', data, action, {page: pageNumber, size: pageSize});
    if (data.data.content.length || data.data.first) {
      yield put(UsersAction.setUserList(data));
      yield put(UsersAction.setUsersLoading(false));
    } else {
      yield put(
        UsersAction.getUserList({
          isActive: filter.isActive,
          pageFilter: {
            size: filter.pageFilter.size,
            page: filter.pageFilter.page - 1,
          },
        })
      );
    }
  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
    yield put(UsersAction.setUsersLoading(false));
  }
}

function* assignInvestigationsSaga(action) {
  const { data, callback, userName } = action.payload;
  try {
    const transformed = transformInvestToEdit(data);
    yield apiInvestigationService.changeAssignedUser({
      invIds: transformed,
      userName: userName.userName,
    });
  } catch (e) {
    yield SettingsAction.handleAPIError(e);
    yield callback();
  }
}

function* getQuickUserListSaga(action) {
  const {query = '', callback} = action.payload;

  const filters = {
    isActive: true,
    pageFilter: {
      page: 0,
      size: 100,
      sortBy: "userName",
    },
  };

  const currentGroup = yield select(selectActiveGroup);
  try {
    if (currentGroup) {
      filters.groupId = currentGroup?.id;
    }
    if (query) {
      filters.userName = query;
    }

    const { data } = yield apiUsersService.getUsers(filters);
    const { content = [] } = data;
    callback(content);
  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
    callback(null);
  }
}

function* updateQuota(action) {
  const {page, id, ...userQuota} = action.payload;
  /*const data = {
    ...action.payload,
    id: action.payload.id,
    roles: action.payload.roles,
    userName: action.payload.userName,
    password: "",
    webintIsActive: action.payload.webintIsActive,
    profilerIsActive: action.payload.profilerIsActive,
    quota: {
      ...action.payload.initialQuot,
      quotaProfiler: {
        isForever: action.payload.profiler?.isValidityForever,
        validFrom: getQuotaDate(
          action.payload.profiler?.interval[0],
          action.payload.initialQuot?.quotaProfiler?.validFrom
        ),
        expireBy: getQuotaDate(
          action.payload.profiler?.interval[1],
          action.payload.initialQuot?.quotaProfiler?.expiredBy
        ),
        crawler: {
          ...action.payload.initialQuot?.quotaProfiler.crawler,
          maxQuota:
            action.payload.profiler.collection ||
            action.payload.initialQuot?.quotaProfiler?.crawler?.maxQuota ||
            0,
        },
        lookup: {
          ...action.payload.initialQuot?.quotaProfiler.lookup,
          maxQuota:
            action.payload.profiler.monitoring ||
            action.payload.initialQuot?.quotaProfiler?.lookup?.maxQuota ||
            0,
        },
        cases: {
          ...action.payload.initialQuot?.quotaProfiler.cases,
          maxQuota:
            action.payload.profiler.numberOfJobs ||
            action.payload.initialQuot?.quotaProfiler?.cases?.maxQuota ||
            0,
        },
      },
      quotaWebint: {
        isForever: action.payload.webint?.isValidityForever,
        validFrom: getQuotaDate(
          action.payload.webint?.interval[0],
          action.payload.initialQuot?.quotaWebint?.validFrom
        ),
        expireBy: getQuotaDate(
          action.payload.webint?.interval[1],
          action.payload.initialQuot?.quotaWebint?.expiredBy
        ),
        crawler: {
          ...action.payload.initialQuot?.quotaWebint.crawler,
          maxQuota:
            action.payload.webint.collectionOperations ||
            action.payload.initialQuot?.quotaWebint?.crawler?.maxQuota ||
            0,
        },
        monitoring: {
          ...action.payload.initialQuot?.quotaWebint.monitoring,
          maxQuota:
            action.payload.webint.monitoring ||
            action.payload.initialQuot?.quotaWebint?.monitoring?.maxQuota ||
            0,
        },
        cases: {
          ...action.payload.initialQuot?.quotaWebint.cases,
          maxQuota:
            action.payload.webint.numberOfJobs ||
            action.payload.initialQuot?.quotaWebint?.cases?.maxQuota ||
            0,
        },
      },
    },
  };*/
  //console.log('updateQuota saga', action.payload, data);
  try {
    yield apiUsersService.updateUser(id, userQuota);
    yield put(
      UsersAction.getUserList({
        isActive: true,
        pageFilter: { page, size: 10},
      })
    );
  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}

function* createUserSaga(action) {
  const {user, callback = null} = action.payload;
  const {currentPage = 0, ...newUser} = user;

  const data = {
    userName: newUser.userName,
    roles: newUser.roles,
    password: newUser.password,
    groupId: newUser?.groupId,
    permissions: newUser?.permissions || [],
    description: user?.description,
  };
  try {
    const {data: createdUser} = yield apiUsersService.registerUser(data);
    yield put(
      UsersAction.getUserList({
        isActive: true,
        groupId: action.payload?.groupId,
        pageFilter: { size: 10, page: currentPage },
      })
    );
    if (callback) {
      callback(createdUser)
    }
  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}

function* editUserSaga(action) {
  console.log('action.payload in saga', action.payload);
  const {editedUser, callback} = action.payload;
  const { id } = editedUser;
  const { currentPage = 0 } = editedUser;

  const data = {
    isActive: editedUser.isActive,
    userName: editedUser.userName,
    roles: editedUser.roles,
    password: editedUser.password,
    webintIsActive: editedUser.webintIsActive,
    profilerIsActive: editedUser.profilerIsActive,
    topPostsIsActive: editedUser.topPostsIsActive,
    description: editedUser?.description,
    groupId: editedUser.groupId,
    permissions: editedUser.permissions,
    //quota: action.payload.quota || {},
  };
  //console.log('saga data edit user', action.payload);

  try {
    yield apiUsersService.updateUser(id, data);
    yield put(
      UsersAction.getUserList({
        isActive: true,
        groupId: editedUser.groupId,
        pageFilter: { size: 10, page: currentPage },
      })
    );
  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  } finally {
    callback(true);
  }
}

function* editUserNameSaga(action) {
  const { id, newInfo, currentPage = 0, callback } = action.payload;
  console.log('newInfo', newInfo);
  const {username} = yield select(getUser);
  if (newInfo.oldName === 'admin') {
    notification.success({message: i18n.t('Permission denied'), placement: 'bottomRight'});
    callback(true);
  } else {
    try {
      yield apiUsersService.renameUser(id, newInfo);
      if (username === newInfo.oldName) {
        notification.success({
          message: i18n.t("User info has been updated successfully. Please login with your new credentials"),
          placement: "bottomRight",
        });
        yield put(AuthAction.logout({}));
      } else {
        notification.success({
          message: i18n.t("User info has been updated successfully."),
          placement: "bottomRight",
        });
        yield put(
          UsersAction.getUserList({
            isActive: true,
            pageFilter: { size: 10, page: currentPage },
          })
        );
      }

      callback(true);
    } catch (e) {
      yield put(SettingsAction.handleAPIError(e));
      callback(false);
    }
  }

}

function* deleteUserSaga(action) {
  const { currentPage = 0, id } = action.payload.userData;
  //const { callback } = action.payload;
  try {
    //yield axios.delete(`${config.api_users}/${id}`, { headers: authHeader()})
    yield apiUsersService.deleteUser(id);
    yield put(
      UsersAction.getUserList({
        isActive: true,
        pageFilter: { size: 10, page: currentPage },
      })
    );
  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}

function* getUserInfoSaga(action) {
  const callback = action.payload;
  try {
    const { data } = yield apiUsersService.getUserInfo();
    const authData = yield select(getUser);
    const transData = transformUserPermissions(data, authData);
    yield put(UsersAction.updateUserState({permissions: transData, userQuota: data?.quota}));

    callback(transData);
  } catch (e) {
    yield SettingsAction.handleAPIError(e);
  }
}

function* getUserQuotaSaga(action) {
  //const callback = action.payload;
  try {
    const {username} = yield select(getUser);
    const filter = {
      userName: username,
      isActive: true,
      pageFilter: {
        page: 0, size: 10
      }
    }
    const {data} = yield apiUsersService.getUsers(filter);
    const quotas = data?.content?.find(el => el.userName === username)?.quota;

    //callback(quotas);
    yield put(UsersAction.updateUserState({userQuota: quotas}));
  } catch (e) {
    yield SettingsAction.handleAPIError(e);
  }
}



/*groups sagas*/

function* getGroupsListSaga(action) {
  const callback = action.payload;
  try {
    const {data} = yield apiGroupsService.getUsersGroups({});
    //const data = mockGroups;
    yield put(UsersAction.updateUserState({groups: data, /*activeGroup: data[0]*/}));
    if (callback) {
      callback(data);
    }
  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}

function* createGroupSaga(action) {
  const {groupData, callback} = action.payload;
  try {
    //const createdGroup = groupData;
    const {data: createdGroup} = yield apiGroupsService.createGroup(groupData);
    yield put(UsersAction.getGroupsList());
    yield put(UsersAction.updateUserState({activeGroup: createdGroup}));
    callback(createdGroup);

  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}

function* updateGroupSaga(action) {
  const {groupId, groupData, callback} = action.payload;
  try {
    //const updatedGroup = groupData;
    const {data: updatedGroup} = yield apiGroupsService.updateGroup(groupId, groupData);
    yield put(UsersAction.getGroupsList());
    yield put(UsersAction.updateUserState({activeGroup: updatedGroup}));
    callback(updatedGroup);

  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}

function* deleteGroupSaga(action) {
  const { groupId , callback } = action.payload;

  try {
    const {data: deletedGroup} = yield apiGroupsService.deleteGroup(groupId)
    //yield put(UsersAction.getGroupsList());
    const {data: freshGroups} = yield apiGroupsService.getUsersGroups({});
    yield put(UsersAction.updateUserState({groups: freshGroups, activeGroup: freshGroups?.find(({id}) => id === groupId)}));

    callback(deletedGroup);
    notification.success({
      message: i18n.t("Group has been deactivated successfully."),
      placement: "bottomRight",
    });

  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}

function* deleteGroupForeverSaga(action) {
  const { groupId , callback } = action.payload;

  try {
    const {data: deletedGroup} = yield apiGroupsService.deleteFullGroup(groupId)
    //yield put(UsersAction.getGroupsList());
    const {data: freshGroups} = yield apiGroupsService.getUsersGroups({});
    yield put(UsersAction.updateUserState({groups: freshGroups, activeGroup: freshGroups?.[0]}));

    callback(deletedGroup);
    notification.success({
      message: i18n.t("Group has been deleted successfully."),
      placement: "bottomRight",
    });

  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}

function* activateGroupSaga(action) {
  const { groupId , callback } = action.payload;

  try {
    const {data: deletedGroup} = yield apiGroupsService.recoveryGroup(groupId);
    const {data: freshGroups} = yield apiGroupsService.getUsersGroups({});
    yield put(UsersAction.updateUserState({groups: freshGroups, activeGroup: freshGroups?.find(({id}) => id === groupId)}));

    callback(deletedGroup);
    notification.success({
      message: i18n.t("Group has been activated back successfully."),
      placement: "bottomRight",
    });

  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}

function* getPermissionsAllSaga(action) {
  const callback = action.payload;
  try {
    const {data} = yield apiPermissionsService.getAllPermissions();
    callback(data);
  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}

function* getAdminListSaga(action) {
  const filter = action.payload;

  yield put(UsersAction.setUsersLoading(true));
  try {
    const data = yield apiUsersService.getAdmin(filter);
    if (data.data.content.length || data.data.first) {
      yield put(UsersAction.setUserList(data));
      yield put(UsersAction.setUsersLoading(false));
    }
  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
    yield put(UsersAction.setUsersLoading(false));
  }
}

function* createAdminSaga(action) {
  const data = {
    userName: action.payload.userName,
    roles: action.payload.roles,
    password: action.payload.password,
    permissions: action.payload?.permissions || [],
  };
  const { currentPage = 0, callback = null } = action.payload;
  try {
    const {data: createdAdmin} = yield apiUsersService.registerUser(data);
    yield put(
      UsersAction.getAdminList({
        isActive: true,
        pageFilter: { size: 10, page: currentPage },
      })
    );
    if (callback) {
      callback(createdAdmin);
    }
  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}

function* editAdminSaga(action) {
  console.log('action.payload in saga', action.payload);
  const {editedUser, callback} = action.payload;
  const { id } = editedUser;
  const { currentPage = 0 } = editedUser;

  const data = {
    isActive: editedUser.isActive,
    userName: editedUser.userName,
    roles: editedUser.roles,
    password: editedUser.password,
    permissions: editedUser.permissions,
  };
  //console.log('saga data edit user', action.payload);

  try {
    yield apiUsersService.updateUser(id, data);
    yield put(
      UsersAction.getAdminList({
        isActive: true,
        pageFilter: { size: 10, page: currentPage },
      })
    );
  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  } finally {
    callback(true);
  }
}

function* editAdminNameSaga(action) {
  const { id, newInfo, currentPage = 0, callback } = action.payload;
  console.log('newInfo', newInfo);
  const {username} = yield select(getUser);
  if (newInfo.oldName === 'admin') {
    notification.success({message: i18n.t('Permission denied'), placement: 'bottomRight'});
    callback(true);
  } else {
    try {
      yield apiUsersService.renameUser(id, newInfo);
      if (username === newInfo.oldName) {
        notification.success({
          message: i18n.t("User info has been updated successfully. Please login with your new credentials"),
          placement: "bottomRight",
        });
        yield put(AuthAction.logout({}));
      } else {
        notification.success({
          message: i18n.t("User info has been updated successfully."),
          placement: "bottomRight",
        });
        yield put(
          UsersAction.getAdmin({
            isActive: true,
            pageFilter: { size: 10, page: currentPage },
          })
        );
      }

      callback(true);
    } catch (e) {
      yield put(SettingsAction.handleAPIError(e));
      callback(false);
    }
  }

}

function* deleteAdminSaga(action) {
  const { currentPage = 0, id } = action.payload.userData;
  try {
    yield apiUsersService.deleteUser(id);
    yield put(
      UsersAction.getAdminList({
        isActive: true,
        pageFilter: { size: 10, page: currentPage },
      })
    );
  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}

function* enableGroupChecklistSaga(action) {
  const {groupId, callback} = action.payload;
  try {
    const {data} = yield apiGroupsService.maturityGroupEnable(groupId);

    //update state
    const activeGroup = yield select(selectActiveGroup);
    yield put(UsersAction.updateUserState({activeGroup: {
      ...activeGroup,
      matureEnabled: true,
    }}));

    callback(data);
  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}

function* disableGroupChecklistSaga(action) {
  const {groupId, callback} = action.payload;
  try {
    const {data} = yield apiGroupsService.maturityGroupDisable(groupId);

    //update state
    const activeGroup = yield select(selectActiveGroup);
    yield put(UsersAction.updateUserState({activeGroup: {
        ...activeGroup,
        matureEnabled: false,
      }}));

    callback(data);
  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}

function* getGroupChecklistSaga(action) {
  const {groupId, callback} = action.payload;
  try {
    const {data} = yield apiGroupsService.getCheckList(groupId);
    const transformData = transformGroupCheckList(data);

    callback(transformData);
  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}

function* updateGroupChecklistSaga(action) {
  const {groupId, checkList, callback} = action.payload;
  try {
    const {data} = yield apiGroupsService.updateCheckList(groupId, checkList);

    callback(data);
  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}

export function* watchUsers() {
  yield takeEvery(UsersAction.GET_USER_LIST, getUserListSaga);
  yield takeEvery(UsersAction.CREATE_USER, createUserSaga);
  yield takeEvery(UsersAction.EDIT_USER, editUserSaga);
  yield takeEvery(UsersAction.EDIT_USER_NAME, editUserNameSaga);
  yield takeEvery(UsersAction.DELETE_USER, deleteUserSaga);
  yield takeEvery(UsersAction.UPDATE_QUOTA, updateQuota);
  yield takeEvery(
    UsersAction.GET_INVESTIGATIONS_LIST,
    getInvestigationsListForUsersSaga
  );
  yield takeEvery(UsersAction.GET_QUICK_USER_LIST, getQuickUserListSaga);
  yield takeEvery(UsersAction.ASSIGN_INVESTIGATION, assignInvestigationsSaga);
  yield takeLeading(UsersAction.GET_USER_INFO, getUserInfoSaga);
  yield takeEvery(UsersAction.GET_USER_QUOTA, getUserQuotaSaga);

  yield takeEvery(UsersAction.GET_GROUPS_LIST, getGroupsListSaga);
  yield takeEvery(UsersAction.CREATE_GROUP, createGroupSaga);
  yield takeEvery(UsersAction.EDIT_GROUP, updateGroupSaga);
  yield takeEvery(UsersAction.DELETE_GROUP, deleteGroupSaga);
  yield takeEvery(UsersAction.DELETE_GROUP_FOREVER, deleteGroupForeverSaga);
  yield takeEvery(UsersAction.ACTIVATE_GROUP, activateGroupSaga);
  yield takeEvery(UsersAction.GET_PERMISSIONS_ALL, getPermissionsAllSaga);

  yield takeEvery(UsersAction.GET_ADMIN_LIST, getAdminListSaga);
  yield takeEvery(UsersAction.CREATE_ADMIN, createAdminSaga);
  yield takeEvery(UsersAction.EDIT_ADMIN, editAdminSaga);
  yield takeEvery(UsersAction.EDIT_ADMIN_NAME, editAdminNameSaga);
  yield takeEvery(UsersAction.DELETE_ADMIN, deleteAdminSaga);

  yield takeEvery(UsersAction.ENABLE_GROUP_CHECKLIST, enableGroupChecklistSaga);
  yield takeEvery(UsersAction.DISABLE_GROUP_CHECKLIST, disableGroupChecklistSaga);
  yield takeEvery(UsersAction.GET_GROUP_CHECKLIST, getGroupChecklistSaga);
  yield takeEvery(UsersAction.UPDATE_GROUP_CHECKLIST, updateGroupChecklistSaga);
}
